import { Component } from '../helpers/helper';
import { state, store_url } from '../state';
import { transport } from '../firebaseTransport';

const AppTile = Component((p: { app: IAppInfo }) => {
	return () => (
		<div
			class={{ appImage: true }}
			onClick={e => {
				state.appInfo = p.app;
				state.stopBrowsingApps();
				if (state.hasChannel) {
					transport.broadcast({
						type: 'activate_app',
						appId: p.app.id,
						name: p.app.name,
						url: p.app.launch_url,
						image: p.app.tile_image,
						includeSelf: true
					}).catch(err => console.error('activate_app failed', err));
				}
			}}
		>
			<img src={store_url + p.app.tile_image} />
			<h1>{p.app.name}</h1>
			<div class="desc">{p.app.description}</div>
		</div>
	);
});

export const Store = Component(() => {
	return () => (
		<div class="dlg-wrapper" onClick={e => state.stopBrowsingApps()}>
			<div id="store" onClick={e => e.stopPropagation()}>
				{state.appList.map(a => (
					<AppTile app={a}></AppTile>
				))}
			</div>
		</div>
	);
});
